import React from "react";

const NextArrow: React.FC = () => {
    return (
        <svg
            width="15"
            height="26"
            viewBox="0 0 15 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M1.40747 1.59248L12.815 13L1.40747 24.4075"
                stroke="#323132"
                stroke-width="2"
                stroke-linecap="round"
            />
        </svg>
    );
};

export default React.memo(NextArrow);
